import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["description", "amount", "selectedItems", "total", "servicesList", "upsellsList", "upsellCard", "upsellCheckbox"]

  connect() {
    this.updateSummary()

    // Listen for service card clicks
    document.addEventListener("change", this.handleServiceChange.bind(this))
  }

  disconnect() {
    document.removeEventListener("change", this.handleServiceChange.bind(this))
  }

  handleServiceChange(event) {
    if (event.target.type === "checkbox" &&
        (event.target.name === "service_ids[]" || event.target.name === "upsell_ids[]")) {
      this.updateCardStyles(event.target)
      this.updateSummary()
    }
  }

  toggleService(event) {
    // Don't toggle if clicking directly on checkbox (it handles itself)
    // Also ignore clicks on buttons (like expandable text toggle)
    if (event.target.type === 'checkbox' || event.target.tagName === 'BUTTON') {
      return
    }

    // Find the card and its checkbox
    const card = event.currentTarget
    const checkbox = card.querySelector('input[type="checkbox"]')

    if (checkbox) {
      checkbox.checked = !checkbox.checked
      this.updateCardStyles(checkbox)
      this.updateSummary()
    }
  }

  toggleUpsell(event) {
    // This is called on checkbox change (label click triggers checkbox)
    const checkbox = event.target
    this.updateCardStyles(checkbox)
    this.updateSummary()
  }

  updateCardStyles(checkbox) {
    const card = checkbox.closest('.selectable-card')
    if (!card) return

    // Service cards use 'selected-primary', upsells use 'selected'
    const isUpsell = checkbox.name === 'upsell_ids[]'
    if (isUpsell) {
      card.classList.toggle('selected', checkbox.checked)
    } else {
      card.classList.toggle('selected-primary', checkbox.checked)
    }
  }

  updateSummary() {
    const items = []
    let total = 0

    // Get custom charge
    if (this.hasDescriptionTarget && this.hasAmountTarget) {
      const description = this.descriptionTarget.value.trim()
      const amount = parseFloat(this.amountTarget.value) || 0

      if (description && amount > 0) {
        items.push({ name: description, price: amount })
        total += amount
      }
    }

    // Get selected services
    const serviceCheckboxes = document.querySelectorAll('input[name="service_ids[]"]:checked')
    serviceCheckboxes.forEach(checkbox => {
      const card = checkbox.closest('.selectable-card')
      if (card) {
        // Get name from h3 element
        const nameEl = card.querySelector('h3')
        const name = nameEl ? nameEl.textContent.trim() : 'Service'
        // Get price from data-base-price (in cents) and convert to dollars
        const priceCents = parseInt(card.dataset.basePrice) || 0
        const price = priceCents / 100
        items.push({ name, price })
        total += price
      }
    })

    // Get selected upsells
    const upsellCheckboxes = document.querySelectorAll('input[name="upsell_ids[]"]:checked')
    upsellCheckboxes.forEach(checkbox => {
      const card = checkbox.closest('.selectable-card')
      if (card) {
        // Get name from h3 element
        const nameEl = card.querySelector('h3')
        const name = nameEl ? nameEl.textContent.trim() : 'Add-on'
        // Get price from data-price (in cents) and convert to dollars
        const priceCents = parseInt(card.dataset.price) || 0
        const price = priceCents / 100
        items.push({ name, price })
        total += price
      }
    })

    // Update selected items display
    if (this.hasSelectedItemsTarget) {
      if (items.length > 0) {
        this.selectedItemsTarget.innerHTML = items.map(item => `
          <div class="flex justify-between text-sm">
            <span class="text-gray-700 dark:text-gray-300">${this.escapeHtml(item.name)}</span>
            <span class="font-medium text-gray-900 dark:text-white">$${item.price.toFixed(2)}</span>
          </div>
        `).join('')
      } else {
        this.selectedItemsTarget.innerHTML = '<p class="text-sm text-gray-500 dark:text-gray-400">No items added yet</p>'
      }
    }

    // Update total
    if (this.hasTotalTarget) {
      this.totalTarget.textContent = `$${total.toFixed(2)}`
    }
  }

  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}
